// Which deployed origin a bundle is running on. `import.meta.env.PROD` is true for
// every build mode (Vite forces NODE_ENV=production for `vite build` regardless of
// --mode), so the hostname is what actually distinguishes the environments.
// Anything not listed here — localhost, a preview build, an unexpected host — is
// treated as local and sends nothing.
const ENVIRONMENT_BY_HOSTNAME = {
  'app.wiseppc.com': 'production',
  'stage.wiseppc.com': 'staging',
  'dev.wiseppc.com': 'development',
};

export const getSentryRuntimeConfig = ({ hostname, isProdBuild }) => {
  const environment = (isProdBuild && ENVIRONMENT_BY_HOSTNAME[hostname]) || 'local';
  const isProd = environment === 'production';

  return {
    isProd,
    enabled: environment !== 'local',
    environment,
    // Traces and session replay are production-only: both ran at 100% on dev and
    // stage, which was the quota burn. Non-production keeps error events only.
    tracesSampleRate: isProd ? 0.1 : 0,
    replaysSessionSampleRate: isProd ? 0.1 : 0,
    // Must be 0 wherever replay is unwanted, not merely where the client is disabled.
    // A non-zero error rate with a zero session rate puts Replay into buffer mode —
    // continuous in-memory recording — and dev/stage now have an enabled client, so
    // that would actually start.
    replaysOnErrorSampleRate: isProd ? 1.0 : 0,
  };
};
